export const NO_RESTRICTION_OPTION_ID = "0";
export const NO_RESTRICTION_OPTION = {
  icon: null,
  name: "No Restriction",
  id: NO_RESTRICTION_OPTION_ID,
  externalId: NO_RESTRICTION_OPTION_ID,
};

export const DIETARY_RESTRICTION_KEY = "dietaryRestrictions";
export const DIETARY_RESTRICTION_OTHER_KEY = "other";
export const PREFERENCE_KEY = "dietaryPreference";
export const RESTRICTION_KEY = "restrictions";

export const RESTRICTION_TAXON_NAME = "Restrictions";

export const ELASTIC_SEARCH_DELAY = 1000;
